import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PageBase, ServiceGuyTypeInfo, UIService } from 't4core';
import { T4DatatableWidget } from "../../../../t4common";


@Component({
  styleUrls: ['./ServiceGuysTypesView.css'],
  selector: 'ServiceGuysTypesView',
  templateUrl: './ServiceGuysTypesView.html',
})

export class ServiceGuysTypesViewComponent extends PageBase implements OnInit {

  @ViewChild("serviceGuyTypesTable")
  private serviceGuyTypesTable: T4DatatableWidget;

  public listObject: ServiceGuyTypeInfo[] = [];

  constructor(el: ElementRef,) {
    super(el, "InventoryStatusDashboard");
  }

  public async ngOnInit() {
    this.listObject =await this.Api.get<ServiceGuyTypeInfo[]>("/Service/GetServiceGuyTypes", {})
  }

  public async createType() {
    var newType = new ServiceGuyTypeInfo();
    var ret = await this.UI.openDialog('T4.Service.ServiceGuyTypeDialog', { data: { newType: newType } });
    if (ret) {
      this.listObject = await this.Api.get<ServiceGuyTypeInfo[]>("/Service/GetServiceGuyTypes", {})
    }
    
  }

  public async editType(row: any) {
    var ret = await this.UI.openDialog('T4.Service.ServiceGuyTypeDialog', { data: { type: row } });
    /*this.serviceGuyTypesTable.update();*/
    if (ret) this.listObject = await this.Api.get<ServiceGuyTypeInfo[]>("/Service/GetServiceGuyTypes", {})
  }

  public async removeType(typeId: any) {

    var ret = await this.UI.confirm('T4.Service.ServiceGuysTypes.headConfirmDelete', 'Are you sure?', 'T4.Service.ServiceGuysTypes.msgConfirmDelete', 'Are you sure you want to delete this service guy type?');
    if (ret) {
      var token = this.UI.beginLoading("T4.Service.ServiceGuysTypes.ldrDeletingServiceGuyType", "Deleting service guy type", null);
      var ret = await this.Api.post<boolean>("/Service/DeleteServiceGuyType", null, { typeId: typeId });
      /*this.serviceGuyTypesTable.update();*/
      this.listObject = await this.Api.get<ServiceGuyTypeInfo[]>("/Service/GetServiceGuyTypes", {})
      this.UI.loaderCompleted(token);
    }

    
  }

}
